module.exports = __webpack_public_path__ + "img/import.0dd067da.svg";